import React from 'react';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import contactUsServices from '../../services/contactUs.services';
import mobileImg from '../assets/img/contact-img1.png';
import { ContactUsSchema } from '../../schema/ContactUsSchema';
import TextError from '../../helpers/FormikHelper/TextError';

const ContactForm = () => {
    const onSubmit = async (values, actions) => {
            const result = await contactUsServices.creatApi(values);
            if (result.data.status === true) {
                actions.resetForm();
                toast.success('Your query submitted', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        } 
    return (

        <section className="contact-form">
            <div className="container c_container">
                <div className="row">
                    <div className="col-12">
                        <div className="contactForm-header text-center">
                            <h6 className="small-heading" data-aos="fade-up">Clinical Pathway</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">For any query fill the form below. For career, related requests use <span>career page.</span></h3>
                        </div>
                        <div className="contactForm-body">
                            <div className="row">
                                <div className="col-lg-5">
                                    <img src={mobileImg} alt="" className="w-100" data-aos="fade-up" />
                                </div>
                                <div className="col-lg-6 offset-lg-1">
                                    <div className="contactForm">
                                        <Formik
                                            initialValues={{ name: '', email: '', message: '', contact_no: '' }}
                                            validationSchema={ContactUsSchema('add')}
                                            onSubmit={onSubmit}
                                            
                                        >
                                            {({ setFieldValue, values }) => (<Form>
                                                <div className="form-group" data-aos="fade-up">
                                                    <label htmlFor="name">Name</label>
                                                    <Field className="form-control" id="name" type="text" name="name" placeholder="Enter you name" />
                                                    <ErrorMessage name='name' component={TextError} />

                                                </div>
                                                <div className="form-group" data-aos="fade-up">
                                                    <label htmlFor="email">E-Mail Address</label>
                                                    <Field className="form-control" id="email" type="email" name="email" placeholder="xyz@gmail.com" />
                                                    <ErrorMessage name='email' component={TextError} />

                                                </div>
                                                <div className="form-group" data-aos="fade-up">
                                                    <label htmlFor="contact_no">Mobile Number</label>
                                                    <Field className="form-control" id="contact_no" type="text" name="contact_no" placeholder="+91 98745 61230" />
                                                    <ErrorMessage name='contact_no' component={TextError} />

                                                </div>
                                                <div className="form-group" data-aos="fade-up">
                                                    <label htmlFor="message">Message</label>
                                                    <textarea className="form-control" id="message" name="message" placeholder="Type your Query" defaultValue={""} 
                                                      value={values.message} 
                                                      onChange={(event) => setFieldValue("message", event.target.value)} 
                                                    />
                                                   <ErrorMessage name='message' component={TextError} />

                                                </div>
                                                <button className="btn custom-btn2 mt-3" type="submit" data-aos="fade-up" >Submit</button>
                                                </Form>
       )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;